import { useCallback } from 'react';
import { Card, Form } from 'react-bootstrap';

import { useFormikContext } from 'formik';

import { updateQueryStringOnFieldChange } from '@components/Filters/Filters';
import { useThrottle } from '@features/useThrottle';

export const BalanceHistoryFilter = ({ searchParams, setSearchParams }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  const throttle = useThrottle((event) => {
    updateQueryStringOnFieldChange(event, { searchParams, setSearchParams });
  }, 500);
  const throttledChangeHandler = useCallback(
    (event) => {
      handleChange(event);
      throttle(event);
    },
    [throttle]
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Show Calls</Card.Header>
      <Card.Body>
        <Form.Group className="mb-3" controlId="formGroupInvoiceID">
          <Form.Label>Show</Form.Label>
          <Form.Select
            name="showCalls"
            size="sm"
            value={values.showCalls}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          >
            <option value={false}>Do not show calls</option>
            <option value>Show calls</option>
          </Form.Select>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};
